/**
 * 公用常量
 */
const serviceDomain = "";

export const URLs = {
    LEFT_MENU_GET: serviceDomain + "/xiaoyue-operation/navigation/newList",
    BATCH_IMPORT_UPLOAD: serviceDomain + "/xiaoyue-operation/new_corpus/import_faq/import",
    BATCH_IMPORT_HISTORY: serviceDomain + "/xiaoyue-operation/new_corpus/import_faq/list",
    BATCH_EXPORT_HISTORY: serviceDomain + "/xiaoyue-operation/new_corpus/export_faq/list",
    FAQ_SYNC_TO_TEST: serviceDomain + "/xiaoyue-operation/new_corpus/sync_faq_to_test/sync",
    FAQ_SYNC_LIST: serviceDomain + "/xiaoyue-operation/new_corpus/sync_faq_to_test/list",
    BATCH_IMPORT_EERORINFO: getServerDomain() + "/xiaoyue-operation/new_corpus/import_faq/error_info/download",
    GET_IMPORT_EERORINFO_TOKEN: serviceDomain + "/xiaoyue-operation/token/create",
    TREES_LIST: serviceDomain + "/xiaoyue-operation/selectSetInfo",
    TREES_ADD: serviceDomain + "/xiaoyue-operation/insertSetInfo",
    TREES_UPDATE: serviceDomain + "/xiaoyue-operation/updateSetInfo",
    TREES_DELETE: serviceDomain + "/xiaoyue-operation/deleteSetInfo",
    QUESTION_LIST_GET: serviceDomain + "/xiaoyue-operation/newSelectCorpus",
    QUESTION_LOCKING_STATUS_UPDATE: serviceDomain + "/xiaoyue-operation/std_question_lock/dolock",
    SEARCH_SIMILAR_QUESTION_ONE: serviceDomain + "/xiaoyue-operation/newSelectCorpus/searchQuestionByMqa",
    SEARCH_QUESTION_BY_AC: serviceDomain + "/xiaoyue-operation/newSelectCorpus/searchQuestionByAc",
    QUES_CREATOR_GET: serviceDomain + "/xiaoyue-operation/question_creator/get",
    ONLINE_OFF_UPDATE: serviceDomain + "/xiaoyue-operation/std_question_status/update",
    TRANSFER_QUES_UPDATE: serviceDomain + "/xiaoyue-operation/new_corpus/faq/transfer",
    TRANSFER_IS_EXIST_ALONG_MIN_LANG: serviceDomain + "/xiaoyue-operation/new_corpus/faq/isExistAloneMinLang",
    QUES_DETAIL_GET: serviceDomain + "/xiaoyue-operation/new_corpus/faq/search",
    QUES_EDIT_SAVE: serviceDomain + "/xiaoyue-operation/new_corpus/faq/save",
    QUES_EDIT_UPDATE: serviceDomain + "/xiaoyue-operation/new_corpus/faq/update",
    QUES_LIST_BY_NAME: serviceDomain + "/xiaoyue-operation/new_corpus/question/searchQuestion",
    USER_OA_INFO: serviceDomain + "/xiaoyue-operation/manager/getOAInfo",
    USER_LEADER_INFO_GET: serviceDomain + "/xiaoyue-operation/manager/getUserInfo",
    GET_BUSINESS_OWNERS: serviceDomain + "/xiaoyue-operation/manager/getUserGameList",
    BUSINESS_OWNERS_INFO_GET: "",
    SUBMIT_BUSINESS_AND_EMAIL: serviceDomain + "/xiaoyue-operation/gbot/add",
    QUES_ANSWER_TEXT_GET: serviceDomain + "/xiaoyue-operation/answer/displayAnswerInfo",
    GET_ALL_GAME_LIST: serviceDomain + "/xiaoyue-operation/game/xinyue/search",
    MOVE_QUESTION_TREES: serviceDomain + "/xiaoyue-operation/new_corpus/set/move",
    SET_FIRST_DEFAULT: serviceDomain + "/xiaoyue-operation/setFirstQuestion",
    SET_REVEAL: serviceDomain + "/xiaoyue-operation/setNoAnswerQuestion",
    OUTER_SUBMIT_APPLY_DATA: serviceDomain + "/xiaoyue-operation/application/add",
    GET_OUTER_APPLY_STATUS: serviceDomain + "/xiaoyue-operation/application",
    OUTER_LOGOUT: serviceDomain + "/xiaoyue-operation/logout",
    SAVE_CLUSTER_QUESTION: serviceDomain + "/xiaoyue-operation/new_corpus/ext_question/add",
    TRANSFRE_SIMILAR_QUES: serviceDomain + "/xiaoyue-operation/new_corpus/ext_question/transfer",
    SEARCH_REC_SIMILARS: serviceDomain + "/xiaoyue-operation/new_corpus/ext_question/searchRecommendQuestion",
    GET_WIDGETS_COLOR: serviceDomain + "/xiaoyue-operation/setting",
    SETTING_WIDGETS_COLOR: serviceDomain + "/xiaoyue-operation/setting/update",
    GET_ASK_ANSWER_LOG: serviceDomain + "/xiaoyue-operation/data_analysis/chat_log/list",
    EXPORT_ASK_ANSWER_LOG: getServerDomain() + "/xiaoyue-operation/data_analysis/chat_log/download",
    GET_RECOMMEND_SHORTBAR: serviceDomain + "/xiaoyue-operation/recommend_shortbar_question/v2/get",
    ACCOUNT_LIST_GET: serviceDomain + "/xiaoyue-operation/personnel_manage/member/search",
    ACCOUNT_DATA_DELTE: serviceDomain + "/xiaoyue-operation/personnel_manage/member/delete",
    GROUP_OPTIONS_GET: serviceDomain + "/xiaoyue-operation/personnel_manage/group/getAllList",
    ROLE_OPTIONS_GET: serviceDomain + "/xiaoyue-operation/personnel_manage/role/getAllList",
    ACCOUNT_EDIT_SAVE: serviceDomain + "/xiaoyue-operation/personnel_manage/member/add",
    ACCOUNT_STATUS_UPDATE: serviceDomain + "/xiaoyue-operation/personnel_manage/member/changeStatus",
    ACCOUNT_EDIT_UPDATE: serviceDomain + "/xiaoyue-operation/personnel_manage/member/update",
    GROUP_LIST_GET: serviceDomain + "/xiaoyue-operation/personnel_manage/group/search",
    GROUP_DATA_DELTE: serviceDomain + "/xiaoyue-operation/personnel_manage/group/delete",
    GROUP_STATUS_UPDATE: serviceDomain + "/xiaoyue-operation/personnel_manage/group/changeStatus",
    GROUP_EDIT_SAVE: serviceDomain + "/xiaoyue-operation/personnel_manage/group/add",
    GROUP_EDIT_UPDATE: serviceDomain + "/xiaoyue-operation/personnel_manage/group/update",
    ROLE_LIST_GET: serviceDomain + "/xiaoyue-operation/personnel_manage/role/search",
    ROLE_DATA_DELTE: serviceDomain + "/xiaoyue-operation/personnel_manage/role/delete",
    ROLE_STATUS_UPDATE: serviceDomain + "/xiaoyue-operation/personnel_manage/role/changeStatus",
    ROLE_EDIT_SAVE: serviceDomain + "/xiaoyue-operation/personnel_manage/role/add",
    ROLE_EDIT_UPDATE: serviceDomain + "/xiaoyue-operation/personnel_manage/role/update",
    TAG_TREES_SEARCH: serviceDomain + "/xiaoyue-operation/form_manage/tags/search",
    UPDATE_ZHIJI_TAG_TREES: serviceDomain + "/xiaoyue-operation/form_manage/tags/update",
    DELETE_ZHIJI_TAG_TREES: serviceDomain + "/xiaoyue-operation/form_manage/tags/delete",
    MOVE_ZHIJI_TAG_TREES: serviceDomain + "/xiaoyue-operation/form_manage/tags/move",
    SAVE_ZHIJI_TAG_TREES: serviceDomain + "/xiaoyue-operation/form_manage/tags/save",
    GET_FORM_LIST: serviceDomain + "/xiaoyue-operation/form_manage/form/list",
    CREATE_ZHIJI_FORMS: serviceDomain + "/xiaoyue-operation/form_manage/form/add",
    UPDATE_ZHIJI_FORMS: serviceDomain + "/xiaoyue-operation/form_manage/form/update",
    DELETE_ZHIJI_FORMS: serviceDomain + "/xiaoyue-operation/form_manage/form/delete",
    COPY_ZHIJI_FORMS: serviceDomain + "/xiaoyue-operation/form_manage/form/copy",
    SET_DEFAULT_ZHIJI_FORMS: serviceDomain + "/xiaoyue-operation/form_manage/form/setDefaultForm",
    CANCEL_DEFAULT_ZHIJI_FORMS: serviceDomain + "/xiaoyue-operation/form_manage/form/cancelDefaultForm",
    IS_Exist_DEFAULT_ZHIJI_FORMS: serviceDomain + "/xiaoyue-operation/form_manage/form/isExistDefaultForm",
    UPDATE_ZHIJI_FORM_STATUS: serviceDomain + "/xiaoyue-operation/form_manage/form/status",
    GET_ZHIJI_FORM_DETAIL: serviceDomain + "/xiaoyue-operation/form_manage/form/detail",
    PERMIT_LIST_GET: serviceDomain + "/xiaoyue-operation/personnel_manage/role/getPermitList",
    GET_ANSWER_PROPS: serviceDomain + "/xiaoyue-operation/answer/tags",
    GET_ANSWER_PROPS_V2: serviceDomain + "/xiaoyue-operation/answer/v2/tags",
    SEARCH_RECOMMEND_SIMILAR: serviceDomain + "/xiaoyue-operation/hot_question/search",
    GET_SYNONYM_QUESTIONS: serviceDomain + "/xiaoyue-operation/new_corpus/faq/questionMap",
    GET_FIRST_RECOMMEND: serviceDomain + "/xiaoyue-operation/setting/conf",
    ADD_FIRST_RECOMMEND: serviceDomain + "/xiaoyue-operation/setting/conf/add",
    UPDATE_FIRST_RECOMMEND: serviceDomain + "/xiaoyue-operation/setting/conf/update",
    GET_CLUSTER_COUNT: serviceDomain + "/xiaoyue-operation/cluster/search",
    DELETE_ALLOT_QUESTION: serviceDomain + "/xiaoyue-operation/cluster/deleteQuestion",
    GET_CONVENTION_LIST: serviceDomain + "/xiaoyue-operation/smart_question/v2/list",
    SEARCH_LOG_DETAIL: serviceDomain + "/xiaoyue-operation/cluster/searchQuestionLog",
    DELETE_CONVENTION: serviceDomain + "/xiaoyue-operation/smart_question/v2/filter",
    TRANSLATE_CONVENTION: serviceDomain + "xiaoyue-operation/helper/batch/translate",
    GET_SENSITIVE_GROUP_LIST: serviceDomain + "/xiaoyue-operation/bot_manager/words/list",
    ADD_SENSITIVE_GROUP: serviceDomain + "/xiaoyue-operation/bot_manager/words/save",
    UPDATE_SENSITIVE_WORDS: serviceDomain + "/xiaoyue-operation/bot_manager/words/update",
    GET_DATA_TREND: serviceDomain + "/xiaoyue-operation/data_overview/bot/list",
    GET_DATA_OVERVIEW: serviceDomain + "/xiaoyue-operation/data_overview/bot/overview",
    GET_HOT_QUESTION: serviceDomain + "/xiaoyue-operation/data_analysis/hot_spot/gbot/hotQuestionStatic",
    GET_HOT_SETS: serviceDomain + "/xiaoyue-operation/data_analysis/hot_spot/gbot/hotSetStatic",
    EXPORT_HOT_SCENE: getServerDomain() + "/xiaoyue-operation/data_analysis/hot_spot/gbot/downloadHotSetsRank",
    EXPORT_HOT_QUESTION: getServerDomain() + "/xiaoyue-operation/data_analysis/hot_spot/gbot/downloadHotQuestionsRank",
    EXPORT_OVERVIEW_DATA: getServerDomain() + "/xiaoyue-operation/data_overview/bot/download",
    GET_DOWNLOAD_TOKEN: serviceDomain + "/xiaoyue-operation/token/create",
    GET_SORT_SET_INFO: serviceDomain + "/xiaoyue-operation/data_analysis/hot_spot/gbot/sortSetInfo",
    EXT_QUESTION_TOTAL_GET: serviceDomain + "/xiaoyue-operation/newSelectCorpus/extQuestTotal",
    ANSWER_TOTAL_GET: serviceDomain + "/xiaoyue-operation/newSelectCorpus/answerTotal",
    GET_ROBOT_DATA_OVERVIEW: serviceDomain + "/xiaoyue-operation/data_overview/bot_monitor",
    GET_ROBOT_DATA_TREND: serviceDomain + "/xiaoyue-operation/data_overview/bot_monitor/hour",
    EXPORT_ROBOT_TREND_DATA: getServerDomain() + "/xiaoyue-operation/data_overview/bot_monitor/downloadTrend",
    GET_SATISFACTION_SENCE: serviceDomain + "/xiaoyue-operation/data_analysis/bot_satisfaction/setStatic",
    GET_QUES_SATISFACTION: serviceDomain + "/xiaoyue-operation/data_analysis/bot_satisfaction/questionStatic",
    GET_SATISFACTION_SET_INFO: serviceDomain + "/xiaoyue-operation/data_analysis/bot_satisfaction/sortSetInfo",
    EXPORT_SATISFACTION_SENCE: getServerDomain() + "/xiaoyue-operation/data_analysis/bot_satisfaction/downloadSetRank",
    EXPORT_SATISFACTION_QUES: getServerDomain() + "/xiaoyue-operation/data_analysis/bot_satisfaction/downloadQuestionsRank",
    SIMILLAR_LIST_GET: serviceDomain + "/xiaoyue-operation/new_corpus/ext_question/search",
    ADD_SIMILAR: serviceDomain + "/xiaoyue-operation/new_corpus/ext_question/add",
    UPDATE_SIMILAR: serviceDomain + "/xiaoyue-operation/new_corpus/ext_question/update",
    DELETE_SIMILAR: serviceDomain + "/xiaoyue-operation/new_corpus/ext_question/delete",
    GET_MATERIAL_TREES_LIST: serviceDomain + "/xiaoyue-operation/resource/tag/search",
    ADD_MATERIAL_TAG: serviceDomain + "/xiaoyue-operation/resource/tag/save",
    UPDATE_MATERIAL_TAG: serviceDomain + "/xiaoyue-operation/resource/tag/update",
    DELETE_MATERIAL_TAG: serviceDomain + "/xiaoyue-operation/resource/tag/delete",
    MOVE_MATERIAL_TAG: serviceDomain + "/xiaoyue-operation/resource/tag/move",
    GET_VLINK_PICTURE_LIST: serviceDomain + "/xiaoyue-operation/resource/image/search",
    UPLOAD_IMAGE: serviceDomain + "/xiaoyue-operation/uploadImage",
    ADD_ONE_PICTURE: serviceDomain + "/xiaoyue-operation/resource/image/save",
    MULTI_ADD_VLINK_PICTURE: serviceDomain + "/xiaoyue-operation/resource/image/batchImageUpload",
    MULTI_SAVE_VLINK_PICTURE: serviceDomain + "/xiaoyue-operation/resource/image/batchImageSave",
    UPDATE_ONE_PICTURE: serviceDomain + "/xiaoyue-operation/resource/image/update",
    DELETE_VLINK_PICTURE: serviceDomain + "/xiaoyue-operation/resource/image/delete",
    GET_VLINK_VIDEO_LIST: serviceDomain + "/xiaoyue-operation/resource/video/search",
    ADD_VLINK_VIDEO: serviceDomain + "/xiaoyue-operation/resource/video/save",
    UPDATE_VLINK_VIDEO: serviceDomain + "/xiaoyue-operation/resource/video/update",
    DELETE_VLINK_VIDEO: serviceDomain + "/xiaoyue-operation/resource/video/delete",
    GET_VLINK_GUIDES: serviceDomain + "/xiaoyue-operation/resource/tip/search",
    ADD_VLINK_GUIDES: serviceDomain + "/xiaoyue-operation/resource/tip/save",
    UPDATE_VLINK_GUIDES: serviceDomain + "/xiaoyue-operation/resource/tip/update",
    DELETE_VLINK_GUIDES: serviceDomain + "/xiaoyue-operation/resource/tip/delete",
    GET_ALL_CHANNEL_DATA: serviceDomain + "/xiaoyue-operation/answer/channel/allGameList",
    GET_MULTI_LANGUAGE: serviceDomain + "/xiaoyue-operation/resource/tag/getMultiLanguage",
    SAVE_MULTI_LANG_EIDT: serviceDomain + "/xiaoyue-operation/resource/tag/editorMultiLanguage",
    SET_RECOMMEND_DATA: serviceDomain + "/xiaoyue-operation/resource/setRecommend",
    REMOVE_RECOMMEND_DATA: serviceDomain + "/xiaoyue-operation/resource/closeRecommend",
    GET_EXPORT_SET_ID_TOTAL: serviceDomain + "/xiaoyue-operation/new_corpus/faq/downloadCorpusBySet/total",
    EXPORT_FAQ_FILE: getServerDomain() + "/xiaoyue-operation/new_corpus/faq/downloadCorpusBySet",
    ADD_PERMIT: serviceDomain + "/xiaoyue-operation/personnel_manage/role/permit/add",
    DELETE_PERMIT: serviceDomain + "/xiaoyue-operation/personnel_manage/role/permit/delete",
    GET_REAOURCE_LIST: serviceDomain + "/xiaoyue-operation/game_wiki/recommend/resource/list",
    ADD_REAOURCE: serviceDomain + "/xiaoyue-operation/game_wiki/recommend/resource/add",
    UPDATE_REAOURCE: serviceDomain + "/xiaoyue-operation/game_wiki/recommend/resource/update",
    DELETE_REAOURCE: serviceDomain + "/xiaoyue-operation/game_wiki/recommend/resource/delete",
    MOVE_REAOURCE: serviceDomain + "/xiaoyue-operation/game_wiki/recommend/resource/move",
    GET_SECTION_LIST: serviceDomain + "/xiaoyue-operation/game_wiki/recommend/section/list",
    ADD_SECTION: serviceDomain + "/xiaoyue-operation/game_wiki/recommend/section/add",
    UPDATE_SECTION: serviceDomain + "/xiaoyue-operation/game_wiki/recommend/section/update",
    DELETE_SECTION: serviceDomain + "/xiaoyue-operation/game_wiki/recommend/section/delete",
    BATCH_SAVE_REAOURCE: serviceDomain + "/xiaoyue-operation/game_wiki/recommend/resource/batchSave",
    SEARCH_USERS: serviceDomain + "/xiaoyue-operation/personnel_manage/member/globalSearch",
    GET_WIKI_CONFIG: serviceDomain + "/xiaoyue-operation/game_wiki/config/get",
    UPDATE_WIKI_CONFIG: serviceDomain + "/xiaoyue-operation/game_wiki/config/save",
    QUES_RELATED_INFO: "/xiaoyue-operation/std_question_status/info",
    CUMULATIVE_DATA: serviceDomain + "/xiaoyue-operation/data_overview/summary/overview",
    TICKET_INDICATOR: serviceDomain + "/xiaoyue-operation/data_overview/summary/range_overview",
    SERVICE_DATA_TREND: serviceDomain + "/xiaoyue-operation/data_overview/summary/trend",
    SERVICE_DATA_DETAIL: serviceDomain + "/xiaoyue-operation/data_overview/summary/list",
    SERVICE_DATA_DETAIL_DOWNLOAD: getServerDomain() + "/xiaoyue-operation/data_overview/summary/list/download",
    GET_COMPONENTS_LIST: getServerDomain() + "/xiaoyue-operation/newSelectCorpus/answerComponent/list",
    GET_ULOG_SEARCHYPE: serviceDomain + "/xiaoyue-operation/operate/newRecordType",
    GET_ULOG_RECORDLIST: serviceDomain + "/xiaoyue-operation/operate/newRecordList",
    GET_ULOG_OPERATORS: serviceDomain + "/xiaoyue-operation/operate/newOperationList",
    CHAT_LOG_EXPORT: serviceDomain + "/xiaoyue-operation/data_analysis/chat_log/export",
    CHAT_LOG_EXPORT_LIST: serviceDomain + "/xiaoyue-operation/data_analysis/chat_log/exportList",
    FQA_EXPORT_BY_SCENEID: serviceDomain + "/xiaoyue-operation/new_corpus/export_faq/export",

    GET_LIKE_CONF: serviceDomain + "/xiaoyue-operation/like/conf/get",
    ADD_LIKE_CONF: serviceDomain + "/xiaoyue-operation/like/conf/add",
    UPDATE_LIKE_CONF: serviceDomain + "/xiaoyue-operation/like/conf/update",
    DELETE_LIKE_CONF: serviceDomain + "/xiaoyue-operation/like/conf/delete",
    LIKE_STATISTIC_DATA_OVERVIEW: serviceDomain + "/xiaoyue-operation/like_statistic/data_overview",
    LIKE_QUESTION_SET_LIST: serviceDomain + "/xiaoyue-operation/like_statistic/question_set/list",
    LIKE_QUESTION_SET_EXPORT: serviceDomain + "/xiaoyue-operation/like_statistic/question_set/export",
    LIKE_QUESTION_LIST: serviceDomain + "/xiaoyue-operation/like_statistic/question/list",
    LIKE_QUESTION_EXPORT: serviceDomain + "/xiaoyue-operation/like_statistic/question/export",
    SATISFACTION_TREND: serviceDomain + "/xiaoyue-operation/like_statistic/satisfaction/trend",
    DISLIKE_HISTOGRAM: serviceDomain + "/xiaoyue-operation/like_statistic/dislike/histogram",
    EXPORT_LIKE_QUESTION: getServerDomain() + "/xiaoyue-operation/like_statistic/question/export",
    EXPORT_LIKE_QUESTION_SET: getServerDomain() + "/xiaoyue-operation/like_statistic/question_set/export",
    CREATE_TOKEN: serviceDomain + "/xiaoyue-operation/token/createTokenWithParams",
};

// 后台响应码err_code定义
export const errorCode = {
    SUCCESS: 0,
    PERSON_SUCCESS: 2, // QQ存在昵称复用
    QQ_ERROR: 1000 // QQ不合法
};

// 静态图片目录
export const STATIC_IMG_PATH = "/zhiji/images/";

// 静态资源目录
export const STATIC_RESOURCE_PATH = `${window.location.pathname.replace("index.html", "")}zhiji/resource/`;

// 问题编辑保存类型
export const quesSaveType = {
    SUBMIT: 1, // 提交
    OFFLINE: 2, // 下线
    DRAFT: 3 // 草稿
};

// 红点开关
export const redPointType = {
    OFF: "0",
    ON: "1"
};

// hot new 标签
export const hotNewType = {
    NONE: "0",
    HOT: "1",
    NEW: "2"
};

// 人员管理 更新 删除
export const personEditType = {
    UPDATE: 0,
    DELETE: 1
};

// 答案状态 启用 停用
export const answerStatus = {
    ENABLE: "1", // 启用
    DISABLE: "0" // 停用
};

// 支持设置超链文本的游戏列表
export const supportTextLinkGameId = [214, 1279, 1306, 1331, 10003, 30001];

// 基础属性默认选中属性ID  178高端 179低端
export const defaultPropId = ["21", "22", "23", "24", "25", "26", "27", "31", "32", "33", "34", "35", "178", "179"];

// 基础属性生效渠道:SDK（登录界面）、SDK(设置)、H5（封号场景）、H5（安全站）
export const effectChannel = ["sdk", "sdk_login", "m_guest", "m_setting", "h5_block", "h5_safety", "mobile", "lite"];

// 答案内容复制key
export const ANSWER_COPY = 'answerCopy';

// C端答案组件类型
export const widgetsType = {
    1: "text", //文本
    5: "tool",
    7: "hotQuestion", //热点问题
    10: "form",
    11: "ticket"
};

export function getServerDomain() {
    const preServiceHost = "//pre-api-interopen.gbot.qq.com/newapi";
    const onlineServiceHost = "//open.vlinkapi.com/newapi";
    const testServiceHost = "//test-api-interopen.gbot.qq.com/newapi";

    const isPreEnv = window.location.host && window.location.host.indexOf("pre-interopen.") > -1;
    const isTest = window.location.host && window.location.host.indexOf("test-interopen.") > -1;

    return isPreEnv ? preServiceHost : isTest ? testServiceHost : onlineServiceHost;
}

// 日志高亮标题
export const highlightTitle = [
    '关联到标准问法ID：',
    '成功导入标准问法数量：',
    '成功导入相似问法数量：',
    '成功导入答案数量：',
    '标准问法名称：',
    '无答案问题：',
    '问题学习ID：',
    '上线标准问法ID：',
    '下线标准问法ID：',
    '删除标准问法ID：',
    '上线标准问题ID：',
    '下线标准问题ID：',
    '删除标准问题ID：',
    '审核通过数量：',
    '审核拒绝数量：',
    '原标准问法ID：',
    '标准问法ID：',
    '相似问法ID：',
    '相似问法：',
    '场景ID：',
    '实体ID：',
    '聚类ID：',
    '更新：',
    '修改为：',
    '名称：',
    '分类ID：',
    '答案ID：',
    '标准问法：',
    '答案标题：',
  ];